import { render, staticRenderFns } from "./taskToApproveLine.vue?vue&type=template&id=ff13941a&scoped=true&"
import script from "./taskToApproveLine.vue?vue&type=script&lang=js&"
export * from "./taskToApproveLine.vue?vue&type=script&lang=js&"
import style0 from "./taskToApproveLine.vue?vue&type=style&index=0&id=ff13941a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff13941a",
  null
  
)

export default component.exports